import { render, staticRenderFns } from "./MenuHours.vue?vue&type=template&id=6c480dab"
import script from "./MenuHours.vue?vue&type=script&lang=ts"
export * from "./MenuHours.vue?vue&type=script&lang=ts"
import style0 from "./MenuHours.vue?vue&type=style&index=0&id=6c480dab&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports